




































































































import { Component, Vue } from 'vue-property-decorator'
import TableComponent from '@/components/TableComponent'
import MainHeader from '@/components/MainHeader'
import moment from 'moment'
import {
  getDistricts,
  getIndustryListRequest,
  getSupervisionDocumentRecordList,
  dowLoadWritenFile
} from '@/api/supervision'
import {getLocalItem} from '@/utils'

@Component({
  components: { TableComponent, MainHeader },
})
export default class WrittenSupervision extends Vue {
  $refs!: { table: HTMLFormElement };
  private lastFetchId = 0; // 只取最后一次结
  private showDetail: boolean = false;
  private showlinkmodal = false;
  private replaceIndustryFields: any = {
    children: 'childList',
    title: 'industryName',
    key: 'id',
    value: 'industryCode',
  };
  private replaceFields: any = {
    children: 'childList',
    title: 'regionName',
    key: 'id',
    value: 'regionCode',
  };
  private industryList: any = [];
  private nameList: any[] = [];
  private searchParams:any = {
    regionCode: null,
    industryCode: null,
    enterpriseCode: undefined,
    
    enterpriseName: null,
    
  };
  // private pageOption = {
  //   showTotal: (total: any) => `共 ${total} 条`,
  //   current: 1,
  //   total: 0,
  //   size: '10',
  // };
  private regionList: any[] = [];
  private fetching: boolean = false; // 查询时的loading
  private detailParams: any = { time: '', id: null, warehouseId: '' };
  private handleDetail(obj: any) {
    this.detailParams.id = obj.id
    this.detailParams.warehouseId = obj.warehouseId
    this.showDetail = true
  }
  private linktype: any = {
    0: '未提审',
    1: '各审核环节名称',
    2: '审核完成',
    3: '审核驳回',
  };
  private format: string = 'YYYY-MM-DD';
  private showEdit: boolean = false;
  private suplier: boolean = false;
  private showBook: boolean = false;
  private showPrint: boolean = false;

  private bookType: number = 0;
  private orderId: string = '';
  private handleEdit(obj: any) {
    this.$router.push({
      path: '/supervisionWriten/add',
      query: { action: 'update', id: obj.id },
    })
    this.showEdit = true
  }
  private handleshowSuplier(obj: any) {
    this.orderId = obj.id
    this.suplier = true
    this.$router.push({
      path: '/supervisionWriten/supervisionInfo',
      query: { action: 'view', id: obj.id,status:obj.status },
    })
  }
  private handleDownload(value:any){
    dowLoadWritenFile(value.id).then((res:any)=>{
       if (res) {
          const blob = new Blob([res], {
            type: 'application/x-www-form-urlencoded'
          })
          const fileName = value.enterpriseName+'书面监察'+value.supervisionPlanTime+'.zip'
          // if (window.navigator.msSaveOrOpenBlob) {
          //   window.navigator.msSaveBlob(blob, fileName)
          // } else {
            const link = document.createElement('a')
            const URL = window.URL || window.webkitURL
            link.href = URL.createObjectURL(blob)
            link.download = fileName
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          // }
          // this.selectedRowKeys = []
          // this.selectedRows = []
        }
    })
  }
  private closesuplier() {
    this.suplier = false
  }
  handleAdd() {
    this.$router.push('/supervisionWriten/add')
  }
  private handleClose() {
    this.showEdit = false
    this.showBook = false
  }
  private columns: any[] = [
    {
      title: '企业',
      dataIndex: 'enterpriseName',
      ellipsis: true,
    },
    {
      title: '所属地区',
      dataIndex: 'regionName',
      key: 'regionName',
      ellipsis: true,
      customRender: (text: any, row: any, index: any) => {
        return text ? text : '-'
      },
    },
    { 
      title: '所属行业',
      dataIndex: 'industryName',
      key: 'industryName',
      ellipsis: true,
      customRender: (text: any, row: any, index: any) => {
        return text ? text : '-'
      },
    },
    {
      title: '计划监察时间',
      dataIndex: 'supervisionPlanTime',
      key: 'supervisionPlanTime',
      ellipsis: true,
       customRender: (text: any, row: any, index: any) => {
            return text ? moment(text).format('YYYY-MM-DD HH:mm:SS') : '--'
        }},
    
    {
      title: '执法人员',
      dataIndex: 'lawEnforcerUserName',
      key: 'lawEnforcerUserName',
      ellipsis: true,
     customRender: (text: any, row: any, index: any) => {
       if(row.lawEnforcerUserList){
return (row.lawEnforcerUserList.map((v:any)=>{
         return v.lawEnforcerUserName
       }).join(','))+','+ row.createUserName
       } else {
         return row.createUserName
       }
      //  var cretaMan:any = ''
      //  if(row.createUserId === this.client.id){
      //    var cretaMan = this.client.realName
      //  }
      
      }
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      customRender: (text: any, row: any, index: any) => {
        const statusMap:any ={
          1:'未下发',
          2:'已下发',
          3:'已送达',
          4:'材料已上传',
          5:'材料不完整',
          6:'材料已补充',
          7:'已通过',
          8:'未通过'
        }
        return statusMap[text]
      },
      ellipsis: true,
    },
    {
      title: '状态变更时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      ellipsis: true,
       customRender: (text: any, row: any, index: any) => {
            return text ? moment(text).format('YYYY-MM-DD HH:mm:SS') : '--'
        }
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      width: 250,
      scopedSlots: { customRender: 'action' },
    },
  ];
  private dataPost = {
    name: '',
  };
  private currentDate: string = '';
  closelink() {
    this.showlinkmodal = false
  }
  showlink(res: any) {
    // // console.log(res)
    this.showlinkmodal = true
  }
  onTimeChange(date: any) {
    this.currentDate = date
    // this.dataPost.time = date
    // this.currentDate = moment(this.dataPost.time, 'YYYY-MM-DD HH:mm:ss')
  }
  private tableData = [];
  // private getList() {
  //   const that = this
  //   return new Promise(function (resolve: any, reject: any) {
  //     const data = {
  //       status: 0,
  //       data: that.tableData,
  //     }
  //     return resolve(data)
  //   })
  // }
  private getList = getSupervisionDocumentRecordList;
  // 分页请求参数 这里可以做一些请求参数的自定义
  private setParams() {
    const data = { ...this.searchParams }
    return data
  }
  handleSearch() {

    this.$refs.table.refresh(true)
  }

  handleResert() {
    this.searchParams ={}
    // this.searchParams.name = ''
    this.$refs.table.refresh(true)
  }
  private pageClick(value: number) {}
 private client:any =getLocalItem('client')
  created() {
    getDistricts(this.client.custRegionCode).then((res: any) => {
      if (res && res.status === 0) {
        this.regionList = [res.data]
      } else {
        this.$message.error(res.message || '获取失败')
      }
    }),
      getIndustryListRequest().then((res: any) => {
        if (res.status == 0) {
          this.industryList = res.data
        }
      })
  }
}
